"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPointerEvent = exports.isKeyboardEvent = exports.userActivationEvents = void 0;
exports.userActivationEvents = ["touchend", "mousedown", "pointerup", "pointerdown", "keydown"];
const isKeyboardEvent = (event) => {
    return event.keyCode !== undefined;
};
exports.isKeyboardEvent = isKeyboardEvent;
const isPointerEvent = (event) => {
    return event.pointerType !== undefined;
};
exports.isPointerEvent = isPointerEvent;
//# sourceMappingURL=user-activation.js.map